import React from 'react';
import './issue-card.scss';
import { SVGS } from '../../assets';
import { kebabCase, startCase } from 'lodash';
import '../../conversations/_conversation-utils.scss';
import { MessageKebabMenu } from '../message-kebab-menu/message-kebab-menu';
import { FIELD_OPS_ROUTES } from '../../constants';
import { useNavigate } from 'react-router-dom';

export const IssueCard: React.FC<{
  id: string;
  time: string;
  msg: string;
  status: string;
  img?: string;
}> = ({ id, time, status, msg, img }) => {
  const navigate = useNavigate();
  const statusClassName = kebabCase(status).toLowerCase();

  const onViewClick = () => {
    navigate(FIELD_OPS_ROUTES.ISSUE_DETAILS + '/' + id);
  };

  return (
    <div className="issue-card">
      <div className="issue-card__header">
        <div className="issue-card__header-left">
          <span className="font-semibold issue-card__header-left-title">
            <img src={SVGS.ErrorPurple} alt="" />
            Issue Created
          </span>
          <div className={`status-details ${status.toLowerCase()}`}>
            <div className={`marker ${statusClassName}`} />
            {startCase(status)}
          </div>
        </div>
        <div className="issue-card__header-right">
          <div className="font-regular issue-card__header-right-time">
            <img src={SVGS.Clock} alt="" /> {time}
          </div>
          <MessageKebabMenu />
        </div>
      </div>
      <div className="issue-card__body-wrapper">
        <div className="message-with-image">
          {img ? (
            <img src={'https://picsum.photos/241/122'} alt="" className="" />
          ) : null}
          <div className="message-with-image-message font-regular">{msg}</div>
        </div>
        <img src={SVGS.Whatsapp} alt="" width={24} />
      </div>
      <div className="issue-card__footer">
        <span className="upload-status font-regular">Uploaded</span>
        <button className="btn btn-primary font-regular" onClick={onViewClick}>
          View Issue <img src={SVGS.ArrowDown} />
        </button>
      </div>
    </div>
  );
};
